import { declareString } from "@1js/localization";

export const DetailMoreLikeThis = declareString(
  "promptLibrary.promptDetailMoreLikeThis",
  {
    text: "More like this",
    comment: `Title that appears for more like this section in prompt details. Under this title there will be two more prompts the user can click on. Those prompts are related to the prompt that the user has already opened.`,
  }
);
